import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'program';

export const programActions = createTypes([
    'save',
    'remove',
    'filterMyPrograms',
    'updateMyProgramList',
], namespace);

export const programActionCreators = {
    save: fromType(programActions.save, ['program']),
    remove: fromType(programActions.remove, ['id']),
    updateMyProgramList: fromType(programActions.updateMyProgramList, ['programsId', 'totalPage', 'page', 'nextPage', 'prePage', 'filters'])
}